import React, { useState, useEffect } from "react";
import { TextInput, SelectInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import { authActions, masterActions, publicUserActions } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { history } from "../../_helpers";
import formatPhoneNumber from "./../../_helpers/formatPhoneNumber";
import deactivateIcon from "../../assets/svg/deactiveate-user.svg";
import emailPendingIcon from "../../assets/svg/email-verification.svg";
import CustomLoader from "./../../components/common/ui/Loader";
import inactive_deactivateIcon from "../../assets/svg/inactive-deactivate.svg";
import activeUserimg from "../../assets/svg/active-user.svg";
import inActiveUserimg from "../../assets/svg/in-active.svg";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission.jsx";

function PublicUserList() {
  const dispatch = useDispatch();
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const stateList = useSelector((x) => x?.master?.stateDrpList);

  const { publicUserStatusOptions } = useSelector((x) => x.dropdownOptions);
  const { publicUsersList, publicUserExcelList, publicUserList, loading } =
    useSelector((x) => x?.publicUser);
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const { PuAccessPermission } = useManagementUserAccessPermission();
  const user = useSelector((x) => x.auth.user);
  const [isloading, setisloading] = useState(false);

  // const [publicUserList, setPublicUserList] = useState({
  //   facilityID: commonFacilityCode,
  //   userName: "",
  //   userLastName: "",
  //   userFirstName: "",
  //   userEmail: "",
  //   phoneNumber: "",
  //   userCity: "",
  //   stateID: 0,
  //   activeStatus: 3,
  //   pageNo: 1,
  //   rowCountPerPage: 10,
  //   sortField: "",
  // });
  const [showSearchFields, setShowSearchFields] = useState(false);

  useEffect(() => {
    if (commonFacilityCode === 0) return;
    dispatch(masterActions.GetStateList());
  }, [commonFacilityCode]);



  useEffect(() => {
    if (publicUserExcelList && publicUserExcelList?.DataList?.length > 0) {
      const title = "PublicUser_List";
      const generateExcelColumns = [
        "Username",
        "Last Name",
        "First Name",
        "Email",
        "Phone Number",
        "City",
        "State",
        "Connection Count",
        "Status",
      ];

      const list = publicUserExcelList?.DataList?.map((obj) => ({
        Username: obj.UserName,
        Last_Name: obj.LastName,
        First_Name: obj.FirstName,
        Email: obj.Email,
        Phone_Number: obj.CellPhone,
        City: obj.City,
        State: obj.StateName,
        Connection_Count: obj.ConnectionAccept,
        Status:
          (obj.ActiveStatus === 1 &&
            obj.DeactivateMyAccount === 0 &&
            obj?.UserActivate === 1 &&
            "Active") ||
          (obj.ActiveStatus === 0 &&
            obj.DeactivateMyAccount === 0 &&
            obj?.UserActivate === 1 &&
            "Inactive") ||
          (obj.ActiveStatus === 1 &&
            obj.DeactivateMyAccount === 1 &&
            obj?.UserActivate === 1 &&
            "Deactivated") ||
          (obj.ActiveStatus === 0 &&
            obj.DeactivateMyAccount === 1 &&
            obj?.UserActivate === 1 &&
            "Inactive and Deactivated") ||
          (obj.UserActivate === 0 &&
            obj.UserActivateDate !== null &&
            "E-mail Reverification Pending"),
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(list, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(publicUserActions.clearDeletePublicListExcelList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [publicUserExcelList]);

  useEffect(() => {
    if (commonFacilityCode === 0) return;
    dispatch(
      publicUserActions?.setpublicUserListSearch({
        ...publicUserList,
        facilityID: commonFacilityCode,
      })
    );
    const searchData = { ...publicUserList };
    searchData.facilityID = commonFacilityCode;
    setisloading(true);
    dispatch(publicUserActions.LoadPublicUsersWithFacility(searchData)).then((x) => { setisloading(false) })
  }, [commonFacilityCode, isPageReloading]);


  // Load facility dropdown on initial
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);

  const handleChange = (e) => {
    const input = e.target;
    let { name, value } = e?.target;

    const originalCursor = input.selectionStart;
    const originalValue = value;

    // Allow @ and . only if the field name is userEmail, otherwise allow only alphanumeric and spaces
    if (name === "userEmail") {
      value = value.replace(/[^a-zA-Z0-9@._\s-]/g, "");
    } else {
      value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }

    //value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    let number;
    if (name === "phoneNumber") {
      // number = formatPhoneNumber(value);
      const digitsOnly = value.replace(/\D/g, "");
      number = formatPhoneNumber(digitsOnly);
    }
    // setPublicUserList((prev) => ({
    //   ...prev,
    //   [name]: name === "phoneNumber" ? number : value,
    // }));

    dispatch(
      publicUserActions?.setpublicUserListSearch({
        ...publicUserList,
        [name]: name === "phoneNumber" ? number : value,
      })
    );
    if (name === "phoneNumber") {
      requestAnimationFrame(() => {
        const inputEl = document.querySelector(`input[name="${name}"]`);
        if (inputEl) {
          const newCursor = calculateNewCursorPosition(
            originalCursor,
            originalValue,
            number
          );
          inputEl.setSelectionRange(newCursor, newCursor);
        }
      });
    }
  };

  const calculateNewCursorPosition = (oldPos, oldVal, newVal) => {
    const digitsBeforeCursor = oldVal
      .slice(0, oldPos)
      .replace(/\D/g, "").length;
    let newCursor = 0;
    let digitCount = 0;

    while (newCursor < newVal.length) {
      if (/\d/.test(newVal[newCursor])) {
        digitCount++;
      }
      if (digitCount === digitsBeforeCursor) {
        newCursor++;
        break;
      }
      newCursor++;
    }

    return newCursor;
  };

  const handleDropdownChange = (selectedOption, name) => {
    const values = { ...publicUserList, pageNo: 1, rowCountPerPage: 10, facilityID: commonFacilityCode };
    if (name === "stateID") {
      const State = selectedOption?.value || 0;
      values.stateID = State;
    } else {
      const statusValue = selectedOption?.value;
      values.activeStatus = statusValue ?? 3;
    }
    // setPublicUserList(values);
    dispatch(publicUserActions?.setpublicUserListSearch(values));
    dispatch(publicUserActions.LoadPublicUsersWithFacility(values));
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    setisloading(true);
    dispatch(
      publicUserActions.LoadPublicUsersWithFacility({
        ...publicUserList,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    ).then((x) => setisloading(false));
    dispatch(
      publicUserActions.setpublicUserListSearch({
        ...publicUserList,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    );
  };

  const handleReset = () => {
    let reset = {
      facilityID: commonFacilityCode,
      userName: "",
      userLastName: "",
      userFirstName: "",
      userEmail: "",
      phoneNumber: "",
      userCity: "",
      stateID: 0,
      activeStatus: 3,
      pageNo: 1,
      rowCountPerPage: 10,
      sortField: "",
    };
    // rowCountPerPage;
    //setPublicUserList(reset);
    dispatch(publicUserActions?.setpublicUserListSearch(reset));
    dispatch(publicUserActions.LoadPublicUsersWithFacility(reset));
  };

  /// Excel download
  const handleClickExcel = () => {
    const updateTotalRows = {
      ...publicUserList,
      RowCountPerPage: publicUsersList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };
    setisloading(true);
    dispatch(publicUserActions.LoadPublicUsersWithFacility(updateTotalRows)).then((x) => { setisloading(false) });
  };

  const navigateToDetailsPage = (row) => {

    dispatch(publicUserActions.clearPhotoGridList());

    if (PuAccessPermission[0]?.SubMenuActiveStatus === 0) {
      // showToastNotification(
      //   "View option has been disabled by the admin.",
      //   "error"
      // );
      //setLinkshow(true);

      return;
    }
    // if (userAccessPermission[0]?.SubMenuActiveStatus === 0) return;

    history.navigate("PublicUserList/Details", {
      state: { row },
    });

    dispatch(publicUserActions?.setPublicUserListRow(row));
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));

  };

  const columns = [
    {
      name: "Username",
      key: "UserName",
      selector: (row) => row.UserName,
      cell: (row) => (
        <div
          onClick={() => navigateToDetailsPage(row)}
          className={` ${PuAccessPermission[0]?.SubMenuActiveStatus !== 0
            ? "Common_Link_Style"
            : ""
            }`}
        >
          {row.UserName}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Last Name",
      key: "LastName",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      name: "First Name",
      key: "FirstName",
      selector: (row) => row?.FirstName,
      sortable: true,
    },
    {
      name: "E-mail",
      key: "Email",
      selector: (row) => row.Email,
      cell: (row) => <div>{row.Email}</div>,
      sortable: true,
    },

    {
      name: "Phone Number",
      key: "CellPhone",
      selector: (row) => row.CellPhone,
      sortable: true,
    },
    {
      name: "City",
      key: "City",
      selector: (row) => row.City,
      sortable: true,
    },
    {
      name: "State",
      key: "StateName",
      selector: (row) => row.StateName,
      sortable: true,
    },
    {
      key: "ConnectionAccept",
      name: "Connection Count",
      selector: (row) => row.ConnectionAccept,
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "ActiveStatusText",
      sortable: true,
      selector: (row) => row.ActiveStatusText,
      cell: (row) => (
        <div>
          {row?.ActiveStatus === 1 &&
            row?.UserActivate === 1 &&
            row?.DeactivateMyAccount === 0 && (
              <img
                title={"Active"}
                alt="alt_image"
                src={activeUserimg}
                style={{ width: "24px", height: "24px" }}
              />
            )}

          {row?.ActiveStatus === 0 &&
            row?.UserActivate === 1 &&
            row?.DeactivateMyAccount === 0 && (
              <img
                title={"Inactive"}
                alt="alt_image"
                src={inActiveUserimg}
                style={{ width: "24px", height: "24px" }}
              />
            )}
          {/* /////////////////////////////////// */}
          {/* 
          {row?.DeactivateMyAccount === 1 && row?.ActiveStatus === 0 && (
            <img
              title={"Inactive"}
              alt="alt_image"
              src={inActiveUserimg}
              style={{ width: "25px", height: "25px" }}
            />
          )} */}

          {row?.DeactivateMyAccount === 1 && row?.ActiveStatus === 0 && (
            <img
              title={"Inactive and Deactivated"}
              alt="alt_image"
              src={inactive_deactivateIcon}
              style={{ width: "24px", height: "24px" }}
            />
          )}

          {row?.DeactivateMyAccount === 1 && row?.ActiveStatus === 1 && (
            <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
              <img
                title={"Deactivated"}
                alt="alt_image"
                src={deactivateIcon}
                style={{ width: "24px", height: "24px" }}
              />
            </div>
          )}
          {/* {row?.ActiveStatusText === "DEACTIVATED" && (
            <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
              <img
                title={"Deactivated"}
                alt="alt_image"
                src={deactivateIcon}
                style={{ width: "25px", height: "25px" }}
              />
            </div>
          )} */}
          {row?.UserActivate === 0 && row?.UserActivateDate !== null && (
            <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
              <img
                title={"E-mail Reverification Pending"}
                alt="alt_image"
                src={emailPendingIcon}
                style={{ width: "24px", height: "24px" }}
              />
            </div>
          )}
        </div>
      ),
    },
  ];

  //grid page Onchange
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    // if (value > 0) {
    dispatch(
      publicUserActions?.setpublicUserListSearch({
        ...publicUserList,
        pageNo: value,
      })
    );
    dispatch(publicUserActions.LoadPublicUsersWithFacility({ ...publicUserList, pageNo: value }));
    // }
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...publicUserList };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    dispatch(publicUserActions?.setpublicUserListSearch(search));

    dispatch(
      publicUserActions.LoadPublicUsersWithFacility({
        ...publicUserList,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  // grid row changes
  const handleRowPerPage = (value) => {
    // setPublicUserList((prevState) => ({
    //   ...prevState,
    //   rowCountPerPage: value,
    // }));
    dispatch(
      publicUserActions?.setpublicUserListSearch({
        ...publicUserList,
        rowCountPerPage: value,
        pageNo: 1,
      })
    );
    dispatch(publicUserActions.LoadPublicUsersWithFacility({ ...publicUserList, pageNo: 1, rowCountPerPage: value }));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row ">
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="userName"
                label="Username"
                value={publicUserList?.userName}
                handleChange={(e) => handleChange(e)}
                placeholder="Username"
                maxLength={50}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="userLastName"
                label="Last Name"
                value={publicUserList?.userLastName}
                handleChange={(e) => handleChange(e)}
                placeholder="Last Name"
                maxLength={50}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="userFirstName"
                label="First Name"
                value={publicUserList?.userFirstName}
                handleChange={(e) => handleChange(e)}
                placeholder="First Name"
                maxLength={50}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="userEmail"
                label="E-mail"
                value={publicUserList?.userEmail}
                handleChange={(e) => handleChange(e)}
                placeholder="E-mail"
                maxLength={50}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="phoneNumber"
                id="phoneNumber"
                label="Phone Number"
                value={publicUserList?.phoneNumber}
                handleChange={(e) => handleChange(e)}
                placeholder="Phone Number"
                maxLength={15}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="userCity"
                label="City"
                value={publicUserList?.userCity}
                handleChange={(e) => handleChange(e)}
                placeholder="City"
                maxLength={50}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                options={stateList}
                label="State"
                name="stateID"
                id="stateID"
                value={publicUserList?.stateID}
                isClearable={publicUserList?.stateID !== 0}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select State"
                handleChange={(e) => handleDropdownChange(e, "stateID")}
              //errorMessage={errorMessage}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="activeStatus"
                options={publicUserStatusOptions}
                value={publicUserList?.activeStatus}
                handleChange={(e) => handleDropdownChange(e, "activeStatus")}
                isClearable={publicUserList?.activeStatus !== 3}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select Status"
                label={"Status"}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            onClick={handleSearch}
            icon={"search"}
            variant="danger"
            status={"primary"}
            disabled={false}
          />

          <Button
            className="me-2"
            label="Reset"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            onClick={handleReset}
            variant="primary "
            status={"secondary"}
            disabled={false}
          />
        </div>
      </form>
    );
  };

  if (loading || isloading) return <CustomLoader />;

  return (
    <div className="public-user-list">
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        {commonFacilityCode > 0 && (
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            {/* Mobile only (Below md breakpoint) */}

            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  Public User search
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>
            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                Public User search
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>

            {/* <div className="row align-items-center">
              <div className="col-md-8 mb-3">
                <h2 className="form_title_uppercase text-color">
                  Public User search
                </h2>
              </div>
            </div> */}

            <div>
              {/* <form>
                <div className="row ">
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="userName"
                        label="Username"
                        value={publicUserList?.userName}
                        handleChange={(e) => handleChange(e)}
                        placeholder="Username"
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="userLastName"
                        label="Last Name"
                        value={publicUserList?.userLastName}
                        handleChange={(e) => handleChange(e)}
                        placeholder="Last Name"
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="userFirstName"
                        label="First Name"
                        value={publicUserList?.userFirstName}
                        handleChange={(e) => handleChange(e)}
                        placeholder="First Name"
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="userEmail"
                        label="E-mail"
                        value={publicUserList?.userEmail}
                        handleChange={(e) => handleChange(e)}
                        placeholder="E-mail"
                        maxLength={50}
                      />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="phoneNumber"
                        id="phoneNumber"
                        label="Phone Number"
                        value={publicUserList?.phoneNumber}
                        handleChange={(e) => handleChange(e)}
                        placeholder="Phone Number"
                        maxLength={15}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="userCity"
                        label="City"
                        value={publicUserList?.userCity}
                        handleChange={(e) => handleChange(e)}
                        placeholder="City"
                        maxLength={50}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <SelectInput
                        options={stateList}
                        label="State"
                        name="stateID"
                        id="stateID"
                        value={publicUserList?.stateID}
                        isClearable={publicUserList?.stateID !== 0}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={false}
                        isLoading={false}
                        placeholder="Select State"
                        handleChange={(e) => handleDropdownChange(e, "stateID")}
                        //errorMessage={errorMessage}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div className="form-floating mb-3">
                      <SelectInput
                        name="activeStatus"
                        options={publicUserStatusOptions}
                        value={publicUserList?.activeStatus}
                        handleChange={(e) =>
                          handleDropdownChange(e, "activeStatus")
                        }
                        isClearable={publicUserList?.activeStatus !== 3}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={false}
                        isLoading={false}
                        placeholder="Select Status"
                        label={"Status"}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
                  <Button
                    className="me-2"
                    label="Search"
                    type="submit"
                    onClick={handleSearch}
                    icon={"search"}
                    variant="danger"
                    status={"primary"}
                    disabled={false}
                  />

                  <Button
                    className="me-2"
                    label="Reset"
                    type="button"
                    icon={"fa-solid fa-rotate-right"}
                    onClick={handleReset}
                    variant="primary "
                    status={"secondary"}
                    disabled={false}
                  />
                </div>
              </form> */}
            </div>
          </div>
        )}

        {commonFacilityCode > 0 ? (
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
              <h2 className="form_title_uppercase text-color">
                Public Users List
              </h2>
              <div className="d-flex flex-wrap justify-content-end">
                {publicUsersList?.DataList?.length > 0 && (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={handleClickExcel}
                  />
                )}
              </div>
            </div>
            <Table
              columns={columns}
              data={publicUsersList?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={publicUsersList?.TotalRecordCount}
              currentPage={publicUserList?.pageNo}
              paginationPerPage={publicUserList?.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={publicUserList?.sortField?.split(" ")[0]}
              sortDirection={publicUserList?.sortField?.split(" ")[1]}
            />
          </div>
        ) : (
          <h4 className="facility-card">
            Select a Facility Code from the list
          </h4>
        )}
      </div>
    </div>
  );
}

export default React.memo(PublicUserList);
